import __utils_axios from "../utils/axios";
import qs from "qs";
import { usePyRequest } from "./usePyConfig";
export default {
  /**
   * 获取fb用户
   * @param params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getFacebookUser(params) {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/FBUser", params);
  },
  /**
   * 获取Ins用户
   * @param {Object} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getInsUser(params) {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/InsUser", params);
  },
  /**
   * 获取 WhatsApp 用户列表，Python 接口使用 GET 并支持国家、标签和日期筛选。
   * @param {{page_id?:string|number;name?:string;country?:string[];label_id?:number[];dateRange?:string[];page?:number;page_num?:number; adaccount_id?:string; ad_id?:string}} params
   * @returns {Promise<DefaultResponseType>}
   */
  getWhatsAppUser(params) {
    return usePyRequest("POST", "api/pandagpt/v1/CSUser/whatsAppUser", params);
  },
  /**
   * 按 WABA 主页获取其全部 WhatsApp 联系二维码。
   * @param {{page_id:string|number}} params 当前列表行的 WABA 主页 ID
   * @returns {Promise<{code:number;msg:string;data:Array<{cleaned:string;country_code:string;phone:string;qrcode:string}>}>}
   */
  getWhatsAppQrCode(params) {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/qrCode", params, false, false, true);
  },
  /**
   * 删除 WhatsApp 联系人，Python 接口按联系人 ID 删除。
   * @param {number|string} contactId 联系人 ID
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  deleteWhatsAppContact(contactId) {
    return __utils_axios("POST", "api/pandagpt/v1/CSUser/delContact", {
      contact_id: contactId
    }, false, false, true);
  },
  /**
   * 导出 WhatsApp 联系人列表，Python 导出接口直接打开下载地址。
   * @param {{page_id:string;date_range:string[];name?:string;label_id?:string;country?:string|string[]}} params
   */
  exportWhatsAppUser(params) {
    const query = {
      ...params,
      token: localStorage.getItem("token") || ""
    };
    window.open(`${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/CSUser/exportUser?${qs.stringify(query)}`);
  },
  /**
   * 获取使用的标签
   * @param {'1'|'2'|'3'} platform 平台: 1 fb; 2 ins; 3 whatsapp
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getAssociationLabel(platform) {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/getAssociationLabel", {
      cs_platform: platform
    });
  },
  /**
   * 获取 WhatsApp 联系人标签下拉框，Python 接口无请求参数。
   * 这里就是get请求
   * @returns {Promise<{code:number;msg:string;data:Array<{id:number|string;name:string}>}|Array<{id:number|string;name:string}>}>}
   */
  getWhatsAppLabels() {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/whatsappLabels", {}, false, false, true);
  },
  /**
   * 获取 WhatsApp 联系人可关联的团队标签列表。
   * @returns {Promise<{code:number;msg:string;data:Array<{id:number|string;name:string}>}>}
   */
  getWhatsAppTeamLabels() {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/teamLabels", {}, false, false, true);
  },
  /**
   * WhatsApp 联系人增加或删除标签，label_ids 为空字符串时表示清空关联标签。
   * @param {{contact_id:number|string;label_ids:string}} params 联系人 ID 和逗号分隔的标签 ID
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  pageAddLabel(params) {
    return __utils_axios("POST", "api/pandagpt/v1/CSUser/pageAddLabel", params, false, false, true);
  },
  /**
   * @typedef {Object} FormUserTag
   * @property {string} cs_platform 平台 1：fb 2:ins 3:whatsapp
   * @property {string} user_id
   * @property {number[]} tags
   * @property {string} [email]
   */
  /**
   * 修改用户标签
   * @param {FormUserTag} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  setUserTags(params) {
    return __utils_axios("POST", "api/pandagpt/v1/CSUser/setUserTags", params);
  },
  /**
   * 获取whatsapp用户国家或地区
   * @param page_id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getUserCountryOrRegion(page_id) {
    return __utils_axios("GET", "api/pandagpt/v1/CSUser/getUserCountry", {
      page_id
    });
  }
};